import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSidebarPin = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.608 3.91a2.25 2.25 0 0 1 3.183 0l5.3 5.3a2.25 2.25 0 0 1 0 3.181l-.592.593a2.25 2.25 0 0 1-2.445.49l-.004-.002-.03-.012h-.002a.75.75 0 0 0-.813.163l-1.337 1.337-.001.002a.75.75 0 0 0-.184.304l-.99 3.162c-.11.347-.301.662-.555.916l-.002.002a2.25 2.25 0 0 1-3.181 0l-5.3-5.3a2.25 2.25 0 0 1 .916-3.738l3.162-.99a.76.76 0 0 0 .308-.187l1.335-1.335a.75.75 0 0 0 .164-.814l-.015-.037a2.25 2.25 0 0 1 .491-2.444zm2.121 1.06a.75.75 0 0 0-1.06 0l-.592.592a.75.75 0 0 0-.164.814l.014.035a2.25 2.25 0 0 1-.49 2.444l-1.336 1.337-.002.002a2.26 2.26 0 0 1-.917.555l-3.16.99a.75.75 0 0 0-.307 1.246l5.3 5.3a.75.75 0 0 0 1.246-.305l.99-3.162a2.25 2.25 0 0 1 .557-.919h.001l1.335-1.335a2.25 2.25 0 0 1 2.445-.492l.004.002.03.012h.002c.28.115.6.05.813-.163l.592-.591a.75.75 0 0 0 0-1.062z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.365 15.634a.75.75 0 0 1 0 1.06L4.53 20.53a.75.75 0 1 1-1.06-1.061l3.834-3.834a.75.75 0 0 1 1.06 0"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSidebarPin);
export default ForwardRef;
